import { render, staticRenderFns } from "./MyTeamEntryOverview.vue?vue&type=template&id=b988fa86&scoped=true"
import script from "./MyTeamEntryOverview.vue?vue&type=script&lang=js"
export * from "./MyTeamEntryOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988fa86",
  null
  
)

export default component.exports